/**
 * Language Switcher Module
 * Handles translation links between DE/EN articles using internal tags
 * Tag format: #translated-to-en-[post-id] or #translated-to-de-[post-id]
 */

function initLanguageSwitcher() {
    const tagsDataElement = document.getElementById('post-tags-data');
    const translationLink = document.getElementById('translation-link');
    const translationFlag = document.getElementById('translation-flag');
    const translationLabel = document.getElementById('translation-label');
    
    if (!tagsDataElement || !translationLink) {
        return;
    }
    
    try {
        const tags = JSON.parse(tagsDataElement.textContent);
        
        // Find translation tag
        const translationTag = tags.find(tag => 
            tag.startsWith('hash-translated-to-en-') || 
            tag.startsWith('hash-translated-to-de-')
        );
        
        if (!translationTag) {
            console.log('No translation tag found');
            return;
        }
        
        // Determine target language and post ID
        let targetLang, postId;
        
        if (translationTag.startsWith('hash-translated-to-en-')) {
            targetLang = 'en';
            postId = translationTag.replace('hash-translated-to-en-', '');
        } else if (translationTag.startsWith('hash-translated-to-de-')) {
            targetLang = 'de';
            postId = translationTag.replace('hash-translated-to-de-', '');
        }
        
        if (!postId) {
            return;
        }
        
        // Fetch the translated post to get its URL
        fetchTranslatedPost(postId, targetLang, translationLink, translationFlag, translationLabel);
        
    } catch (error) {
        console.error('Error parsing post tags:', error);
    }
}

/**
 * Fetch the translated post using Ghost Content API
 */
async function fetchTranslatedPost(postId, targetLang, linkElement, flagElement, labelElement) {
    // Try to get the post URL from Ghost Content API
    // First, try using the post ID directly
    const ghostUrl = window.location.origin;
    
    // Ghost Content API key should be set in the theme or we use a fallback approach
    const apiKey = window.ghostContentApiKey || null;
    
    if (apiKey) {
        try {
            const response = await fetch(
                `${ghostUrl}/ghost/api/content/posts/${postId}/?key=${apiKey}&fields=url,title,slug`
            );
            
            if (response.ok) {
                const data = await response.json();
                if (data.posts && data.posts[0]) {
                    setupTranslationLink(data.posts[0].url, targetLang, linkElement, flagElement, labelElement, data.posts[0].title);
                    return;
                }
            }
        } catch (error) {
            console.log('Could not fetch via API, falling back to slug search');
        }
    }
    
    // Fallback: Try to find the post by searching in the DOM or use a generic approach
    // We'll search for posts with matching translation tags
    findPostByTranslationTag(postId, targetLang, linkElement, flagElement, labelElement);
}

/**
 * Find post URL by looking up the translation in the database via tag
 */
async function findPostByTranslationTag(postId, targetLang, linkElement, flagElement, labelElement) {
    const ghostUrl = window.location.origin;
    const apiKey = window.ghostContentApiKey || null;
    
    // The tag on the OTHER post that points back to THIS post
    const currentPostId = getCurrentPostId();
    const searchTag = targetLang === 'en' ? `hash-translated-to-de-${currentPostId}` : `hash-translated-to-en-${currentPostId}`;
    
    if (apiKey) {
        try {
            // Search for posts with the reverse translation tag
            const response = await fetch(
                `${ghostUrl}/ghost/api/content/posts/?key=${apiKey}&filter=tag:${searchTag}&fields=url,title,slug&limit=1`
            );
            
            if (response.ok) {
                const data = await response.json();
                if (data.posts && data.posts[0]) {
                    setupTranslationLink(data.posts[0].url, targetLang, linkElement, flagElement, labelElement, data.posts[0].title);
                    return;
                }
            }
        } catch (error) {
            console.log('Could not find translation via tag search');
        }
    }
    
    // Final fallback: Just show the link with a hash and let user know translation exists
    setupTranslationLink('#translation-not-found', targetLang, linkElement, flagElement, labelElement);
}

/**
 * Get current post ID from URL or page
 */
function getCurrentPostId() {
    // Try to extract from canonical URL or page metadata
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
        const url = canonical.href;
        // Ghost URLs typically end with the slug
        const parts = url.split('/').filter(Boolean);
        return parts[parts.length - 1];
    }
    return null;
}

/**
 * Setup the translation link with proper URL and flag
 */
function setupTranslationLink(url, targetLang, linkElement, flagElement, labelElement, title = null) {
    if (!linkElement) return;
    
    // Set the URL
    linkElement.href = url;
    
    // Set the flag class
    if (flagElement) {
        flagElement.className = 'flag';
        if (targetLang === 'en') {
            flagElement.classList.add('flag-gb');
        } else if (targetLang === 'de') {
            flagElement.classList.add('flag-de');
        }
    }
    
    // Set the label
    if (labelElement) {
        labelElement.textContent = targetLang.toUpperCase();
    }
    
    // Set title attribute
    if (title) {
        linkElement.title = targetLang === 'en' ? `Read in English: ${title}` : `Auf Deutsch lesen: ${title}`;
    } else {
        linkElement.title = targetLang === 'en' ? 'Read in English' : 'Auf Deutsch lesen';
    }
    
    // Show the link
    linkElement.classList.remove('hidden');
}

/**
 * Alternative: Direct database lookup approach
 * This function can be called if we have the post ID and want to navigate directly
 */
function navigateToTranslation(postId) {
    // Use Ghost Admin API or Content API to get the post URL
    // For now, we'll use a simple redirect approach
    window.location.href = `/p/${postId}/`;
}
